import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { appendDefaultStyle } from '../../../lib/style';
// todo: remove watch functions
export class Input extends LitElement {
    constructor() {
        super(...arguments);
        this.isDate = false;
        this.cssType = 'outlined';
        this.showDecimal = false;
        this.step = '1';
    }
    render() {
        return html `
            <input
                @focusin="${this.focusin}"
                @focusout="${this.focusout}"
                @input="${this.input}"
                @change="${this.change}"
                @blur="${this.blurHandler}"
                .value="${this.value || ''}"
                min="${this.min || ''}"
                max="${this.max || ''}"
                step="${Number(this.step)}"
            />
        `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.setIdToName();
        this.watchType();
        if (this.showDecimal || this.hasAttribute('showDecimal')) {
            this.watchValue();
            return;
        }
        this.watchValue();
        this.watchType();
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('type')) {
            this.watchType();
        }
        if (_changedProperties.has('placeholder')) {
            this.watchPlaceholder();
        }
        if (_changedProperties.has('disabled')) {
            this.watchDisabled();
        }
        if (_changedProperties.has('required')) {
            this.watchRequired();
        }
        if (_changedProperties.has('notValid')) {
            this.watchValid();
        }
        if (_changedProperties.has('cssType')) {
            this.watchCssType();
        }
        if (_changedProperties.has('showDecimal')) {
            this.watchDecimal();
        }
        if (_changedProperties.has('value')) {
            this.watchValue();
        }
    }
    setIdToName() {
        this._input.setAttribute('id', this.name);
    }
    watchDecimal() {
        if (this.showDecimal || this.hasAttribute('showDecimal')) {
            this._input.step = '0.01';
            this.watchValue();
        }
    }
    watchValue() {
        if (this.value !== null && this.value !== 'undefined' && this.value !== undefined) {
            /*
            ** todo: fix this
            if (this.hasAttribute('showDecimal') && this._input.type === 'number') {
                console.log('test', this.value);
                const number = isNaN(Number(this.value)) ? undefined : Number(this.value);
                this.value = isNaN(Number(parseFloat(this.value!).toFixed(2))) ? '' : parseFloat(this.value!).toFixed(2);
                this._input.setAttribute('step', '0.01');
                console.log('test 2', this.value);

                console.log("number", Number.isInteger(number))

                if (Number.isInteger(number)) {
                    this._input.value = this.value + '.00';
                    console.log('test 3', this._input.value);
                    return;
                }
            }*/
            this.hasValue();
            this._input.setAttribute('value', this.value);
            if (this.type === 'week' && this.transformDate !== undefined) {
                this.value = String(this._input.valueAsDate);
            }
            return;
        }
        this.hasValue();
        this._input.removeAttribute('value');
    }
    watchType() {
        this._input.setAttribute('type', this.type);
    }
    watchPlaceholder() {
        if (this.placeholder !== undefined &&
            (this.type == 'text' || this.type == 'search' || this.type == 'url' || this.type == 'tel' || this.type == 'email' || this.type == 'password')) {
            this._input.setAttribute('placeholder', this.placeholder);
            return;
        }
        this._input.removeAttribute('placeholder');
    }
    watchDisabled() {
        if (this.disabled !== undefined) {
            this._input.setAttribute('disabled', '');
            return;
        }
        this._input.removeAttribute('disabled');
    }
    watchRequired() {
        if (this.required !== undefined) {
            this._input.setAttribute('required', '');
            return;
        }
        this._input.removeAttribute('required');
    }
    watchValid() {
        if (this.notValid !== undefined || this.hasAttribute('not-valid')) {
            this._input.style.setProperty('border-color', 'var(--ep-color-danger');
            return;
        }
        this._input.style.removeProperty('border-color');
    }
    watchCssType() {
        if (this.cssType === 'filled') {
            this._input.classList.remove('outlined');
            this._input.classList.add('filled');
            return;
        }
        if (this.cssType === 'outlined') {
            this._input.classList.remove('filled');
            this._input.classList.add('outlined');
            return;
        }
        this._input.classList.remove('outlined');
        this._input.classList.remove('filled');
    }
    hasValue() {
        if ((this.value !== '' && this.value !== null && this.value !== undefined) || this.placeholder !== undefined) {
            this.classList.remove('label-top');
            this.classList.add('label-top');
            return;
        }
        this.classList.remove('label-top');
    }
    focusin(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.classList.add('focus');
        this.dispatchEvent(new CustomEvent('focusin', {
            composed: true
        }));
    }
    focusout(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const value = e.currentTarget.value;
        this.hasValue();
        this.classList.remove('focus');
        this.dispatchEvent(new CustomEvent('focusout', {
            composed: true,
            detail: value
        }));
    }
    blurHandler(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const value = e.currentTarget.value;
        this.hasValue();
        this.dispatchEvent(new CustomEvent('blur', {
            composed: true,
            detail: value
        }));
    }
    input(e) {
        const input = e.currentTarget;
        if (this.isDate || this.type === 'date' || this.type === 'datetime-local' || this.type === 'month' || this.type === 'time' || this.type === 'week') {
            this.dispatchEvent(new CustomEvent('input', {
                composed: true,
                detail: input.value,
                bubbles: false
            }));
            return;
        }
        e.stopImmediatePropagation();
        e.stopPropagation();
        setTimeout(() => {
            this.value = input.value;
            this.dispatchEvent(new CustomEvent('input', {
                composed: true,
                detail: this.value
            }));
        }, 10);
        this.change(e);
    }
    change(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const value = e.currentTarget.value;
        this.value = value;
        if (this.type === 'file') {
            this.dispatchEvent(new CustomEvent('change', {
                composed: true,
                detail: e.currentTarget.files
            }));
            return;
        }
        if (this.type === 'number') {
            if (!isNaN(Number(this.max)) && Number(value) > Number(this.max)) {
                this.value = String(this.max);
            }
            else if (!isNaN(Number(this.min)) && Number(value) < Number(this.min)) {
                this.value = String(this.min);
            }
            else if (Number(this.value) % Number(this.step) !== 0) {
                this.value = String(Math.ceil(Number(this.value) / Number(this.step)) * Number(this.step));
            }
            else if (Number(this.step) === 1) {
                this.value === parseInt(this.value).toString();
            }
        }
        this.dispatchEvent(new CustomEvent('change', {
            composed: true,
            detail: value
        }));
    }
}
Input.styles = appendDefaultStyle(css `
        :host(:focus-visible),
        input:focus-visible {
            outline: 0;
        }

        input:-webkit-autofill:focus {
            background-color: inherit;
        }

        input {
            /* todo:  removed --ep-input-border-bottom && --ep-input-margin && --ep-input-padding check for usage
            */
            line-height: var(--ep-input-line-height, 22px);
            width: var(--ep-input-width, 100%);
            margin: 0;
            padding: var(--ep-input-padding, 5px 5px 5px 13px);
            border: none;
            font-size: var(--ep-input-text-font-size, var(--ep-text-font-size));
            font-family: var(--ep-text-font-family);
            color: var(--ep-text-color);
            border-bottom: 2px solid var(--ep-color-tertiary);
        }

        input[type='number']::-webkit-inner-spin-button,
        input[type='number']::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type='number'] {
            -moz-appearance: textfield;
        }
        /* todo:  removed --ep-input-border && --ep-input-border-radius check for usage*/

        input.outlined {
            border: var(--ep-input-border-width, 2px) solid var(--ep-color-tertiary);
            border-radius: var(--ep-input-border-radius, 3px);
        }

        input::placeholder {
            font-size: var(--ep-input-text-font-size, var(--ep-text-font-size));
            color: var(--ep-text-color);
            opacity: 0.4;
        }

        input:focus {
            border-color: var(--ep-color-primary);
        }

        :host([not-valid]) input,
        :host([notValid]) input {
            border-color: var(--ep-color-danger);
        }

        input:disabled {
            background-color: var(--ep-color-gray-3);
            cursor: not-allowed;
        }

        input[type='number'] {
            text-align: var(--ep-input-number-text-align, right);
        }
    `);
__decorate([
    property()
], Input.prototype, "name", void 0);
__decorate([
    property()
], Input.prototype, "id", void 0);
__decorate([
    property()
], Input.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], Input.prototype, "isDate", void 0);
__decorate([
    property()
], Input.prototype, "value", void 0);
__decorate([
    property({ type: Number })
], Input.prototype, "min", void 0);
__decorate([
    property({ type: Number })
], Input.prototype, "max", void 0);
__decorate([
    property()
], Input.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean })
], Input.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], Input.prototype, "required", void 0);
__decorate([
    property({ type: Boolean })
], Input.prototype, "notValid", void 0);
__decorate([
    property()
], Input.prototype, "cssType", void 0);
__decorate([
    property()
], Input.prototype, "transformDate", void 0);
__decorate([
    property({ type: Boolean })
], Input.prototype, "showDecimal", void 0);
__decorate([
    property({ type: String })
], Input.prototype, "step", void 0);
__decorate([
    query('input')
], Input.prototype, "_input", void 0);
if (!customElements.get('ep-input')) {
    customElements.define('ep-input', Input);
}
//# sourceMappingURL=element.js.map